import { docsUrl } from "@/shared/environment";
import {
  House,
  LayoutDashboard,
  Settings,
  FileText,
  Shield,
  ENTITY_ICONS,
} from "@/shared/foundation/icons";
import { Goto } from "@/shared/navigation/Goto";

export interface NavGroups {
  features: NavLink[];
  actionsAndAgents: NavLink[];
  boards: NavLink[];
  settingsAndGuides: NavLink[];
  admin: NavLink[];
}

export interface NavLink {
  name: string;
  link: string;
  icon: React.ElementType;
  isExternalLink?: boolean;
  /** A short label drawn after the link's name, such as "Beta". */
  badge?: string;
}

export const navGroups: NavGroups = {
  features: [
    {
      name: "Home",
      link: Goto.route.Home,
      icon: House,
    },
    {
      name: "Datasets",
      link: Goto.route.Datasets,
      icon: ENTITY_ICONS.dataset,
    },
    {
      name: "Files",
      link: Goto.route.Files,
      icon: ENTITY_ICONS.file,
    },
    {
      name: "Events",
      link: Goto.route.Events,
      icon: ENTITY_ICONS.event,
    },
    {
      name: "Collections",
      link: Goto.route.Collections,
      icon: ENTITY_ICONS.collection,
    },
    {
      name: "Devices",
      link: Goto.route.Devices,
      icon: ENTITY_ICONS.device,
    },
    {
      name: "Sessions",
      link: Goto.route.Sessions,
      icon: ENTITY_ICONS.session,
    },
    {
      name: "Metrics",
      link: Goto.route.Metrics,
      icon: ENTITY_ICONS.metric,
    },
  ],
  actionsAndAgents: [
    {
      name: "Actions",
      link: "/actions",
      icon: ENTITY_ICONS.action,
    },
    {
      name: "Agents",
      link: Goto.route.Agents,
      icon: ENTITY_ICONS.agent,
    },
    {
      name: "Triggers",
      link: Goto.route.Triggers,
      icon: ENTITY_ICONS.trigger,
    },
  ],
  // `Navigation` draws this group only when `release-boards` is on.
  boards: [
    {
      name: "Boards",
      link: Goto.route.Boards,
      icon: LayoutDashboard,
      badge: "Beta",
    },
  ],
  settingsAndGuides: [
    {
      name: "Settings",
      link: Goto.route.Settings.Root,
      icon: Settings,
    },
    {
      name: "Docs",
      isExternalLink: true,
      link: docsUrl(),
      icon: FileText,
    },
  ],
  admin: [
    {
      name: "Admin",
      link: Goto.route.Admin,
      icon: Shield,
    },
  ],
};
